export const formPersonalProperties = () => {
  // if (process.env.NODE_ENV === 'development') {
  return {};
  // default value not working with dependencies
  // https://github.com/mozilla-services/react-jsonschema-form/issues/975
  // }
  return {
    properties: {
      numberOfPersons: {
        type: 'string',
        title: 'Number of proprietors/partners/directors/guarantors?',
        enum: ['1', '2', '3', '4'],
        default: '2'
      }
    },
    dependencies: {
      numberOfPersons: {
        oneOf: [
          {
            properties: {
              numberOfPersons: {
                enum: ['1']
              },
              person1: {
                title: `Director/Guarantor 1 Details`,
                '$ref': '#/definitions/personalDetails'
              }
            }
          },
          {
            properties: {
              numberOfPersons: {
                enum: ['2']
              },
              person1: {
                title: `Director/Guarantor 1 Details`,
                '$ref': '#/definitions/personalDetails'
              },
              person2: {
                title: `Director/Guarantor 2 Details`,
                '$ref': '#/definitions/personalDetails'
              }
            }
          },
          {
            properties: {
              numberOfPersons: {
                enum: ['3']
              },
              person1: {
                title: `Director/Guarantor 1 Details`,
                '$ref': '#/definitions/personalDetails'
              },
              person2: {
                title: `Director/Guarantor 2 Details`,
                '$ref': '#/definitions/personalDetails'
              },
              person3: {
                title: `Director/Guarantor 3 Details`,
                '$ref': '#/definitions/personalDetails'
              }
            }
          },
          {
            properties: {
              numberOfPersons: {
                enum: ['4']
              },
              person1: {
                title: `Director/Guarantor 1 Details`,
                '$ref': '#/definitions/personalDetails'
              },
              person2: {
                title: `Director/Guarantor 2 Details`,
                '$ref': '#/definitions/personalDetails'
              },
              person3: {
                title: `Director/Guarantor 3 Details`,
                '$ref': '#/definitions/personalDetails'
              },
              person4: {
                title: `Director/Guarantor 4 Details`,
                '$ref': '#/definitions/personalDetails'
              }
            }
          }
        ]
      }
    },
    definitions: {
      address: {
        type: 'object',
        required: [ 'streetAddress', 'city', 'postcode', 'state' ],
        properties: {
          streetAddress: {
            title: 'Street address',
            type: 'string',
            default: 'Test st'
          },
          city: {
            title: 'City',
            type: 'string',
            default: 'Test City'
          },
          postcode: {
            title: 'Postcode',
            minLength: 4,
            maxLength: 4,
            type: 'string',
            default: '4444'
          },
          state: {
            title: 'State',
            type: 'string',
            enum: [
              'New South Wales', 'Victoria', 'Queensland', 'Western Australia',
              'South Australia', 'Tasmania', 'Australian Capital Territory', 'Northern Territory'
            ],
            default: 'Victoria'
          }
        }
      },
      personalDetails: {
        type: 'object',
        required: [
          'fullName', 'email', 'guarantorType', 'residentialAddress', 'dateOfBirth', 'homePhone', 'mobile', 'maritalStatus',
          'dependents', 'residentialStatus'
        ],
        properties: {
          fullName: {
            type: 'string',
            title: 'Name in full',
          },
          email: {
            type: 'string',
            title: 'Email',
          },
          guarantorType: {
            type: 'string',
            title: 'Guarantor Type',
            enum: ['director', 'guarantor'],
            enumNames: ['director', 'non-director']
          },
          residentialAddress: {
            '$ref': '#/definitions/address',
            title: 'Residential address'
          },
          dateOfBirth: { // todo format date
            type: 'string',
            title: 'Date of birth',
            default: '24/12/2000'
          },
          homePhone: {
            type: 'string',
            title: 'Home phone',
            default: '94444444'
          },
          mobile: {
            type: 'string',
            title: 'Mobile',
            default: '0444444444'
          },
          maritalStatus: {
            type: 'string',
            title: 'Marital status',
            enum: ['Single', 'Married', 'Separated', 'Widowed', 'Divorced'],
            default: 'Married'
          },
          dependents: {
            type: 'number',
            title: 'No. of dependants',
            default: '2'
          },
          residentialStatus: {
            type: 'string',
            title: 'Residential status',
            enum: ['Owner occupied', 'Renting', 'Boarding', 'Other'],
            default: 'Owner occupied'
          },
          otherResidentialStatus: {
            type: 'string', // todo optionally show when Other is chosen
            title: 'Other',
            default: 'test other residential status'
          }
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/fixtures/formPersonalProperties.js